import type { AxModelInfo } from '../types.js';

export const axModelInfoTogether: AxModelInfo[] = [];
